import { render, staticRenderFns } from "./ContactAvatar.vue?vue&type=template&id=a00a3580&"
import script from "./ContactAvatar.vue?vue&type=script&lang=ts&"
export * from "./ContactAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports